import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    heatLoanFormView: {
      backgroundColor: '#F2E9E6',
      width: '100%',
      height: 'auto',
      display: 'flex',
      justifyContent: 'center',
    },
    heatLoanFormWidget: {
      width: '47.5%',
      backgroundColor: '#F37320',
      height: '100%',
      marginTop: '1.5em',
      marginBottom: '3.5em',
      display: 'flex',
      flexDirection: 'column',
      '@media (max-width: 1500px)': {
        width: '60%',
        marginBottom: '2.5em',
      },
      '@media (max-width: 1200px)': {
        width: '80%',
      },
      '@media (max-width: 1000px)': {
        width: '100%',
        margin: '0',
      },
    },
    heatLoanFormHODetails: {
      display: 'flex',
      justifyContent: 'space-between',
      paddingLeft: '3.8em',
      paddingRight: '3.8em',
      '@media (max-width: 700px)': {
        flexDirection: 'column',
      },
      '@media (max-width: 550px)': {
        padding: '0',
      },
    },
    heatLoanFormHeader: {
      height: '10%',
      color: '#FFFFFF',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      marginTop: '0.5em',
      marginLeft: '3.5em',
      padding: '0',
      marginRight: '2em',
      textAlign: 'left',
      '@media (max-width: 700px)': {
        height: '15%',
        marginLeft: '1em',
        marginRight: '0',
      },
      '@media (max-width: 500px)': {
        height: '15%',
        marginTop: '0.5em',
        marginLeft: '1em',
        marginRight: '0',
      },
    },
    heatLoanFormTitle: {
      fontSize: '2.5em',
      marginTop: '0.5em',
      '@media (max-width: 450px)': {
        margin: '0',
        fontSize: '2.5em',
      },
      '@media (max-width: 500px)': {
        marginTop: '0.5em',
        fontSize: '2.5em',
      },
    },
    heatLoanFormDescription: {
      fontSize: '0.9em',
      marginTop: '1.5em',
      paddingRight: '1em',
      marginBottom: '2em',
      '@media (max-width: 600px)': {
        fontSize: '0.7em',
      },
      '@media (max-width: 400px)': {
        fontSize: '0.5em',
      },
    },
    formDividerHomeOwnerDetails: {
      marginTop: '0.5em',
      marginRight: '2em',
      marginLeft: '2em',
      padding: '0.06%',
      '@media (max-width: 550px)': {
        marginTop: '0',
        marginRight: '1em',
        marginLeft: '1em',
        padding: '0.05%',
      },
      backgroundColor: '#A9A9A9',
    },
    formDividerHomeOwnerForms: {
      marginTop: '0.5em',
      marginRight: '2em',
      marginLeft: '2em',
      padding: '0.06%',
      '@media (max-width: 550px)': {
        marginTop: '0',
        marginRight: '1em',
        marginLeft: '1em',
        padding: '0.05%',
      },
      backgroundColor: '#A9A9A9',
    },
    formDividerInstallerDetails: {
      marginTop: '0.5em',
      marginRight: '2em',
      marginLeft: '2em',
      padding: '0.06%',
      '@media (max-width: 550px)': {
        marginTop: '0',
        marginRight: '1em',
        marginLeft: '1em',
        padding: '0.05%',
      },
      backgroundColor: '#A9A9A9',
    },
    formLabel: {
      fontWeight: 'bold',
      fontSize: '1.2em',
      display: 'flex',
      color: '#505050',
      justifyContent: 'flex-start',
      paddingLeft: '3.2em',
      paddingRight: '3.5em',
      paddingBottom: '1.75em',
      paddingTop: '1.5em',
      '@media (max-width: 550px)': {
        paddingLeft: '1em',
        paddingRight: '1.5em',
        fontSize: '1.1em',
      },
    },
    formLabel2: {
      fontWeight: 'bold',
      fontSize: '1.2em',
      display: 'flex',
      color: '#505050',
      justifyContent: 'flex-start',
      paddingLeft: '3.5em',
      paddingRight: '3.5em',
      paddingTop: '1.5em',
      paddingBottom: '1em',
      '@media (max-width: 550px)': {
        paddingLeft: '1.5em',
        paddingRight: '1.5em',
        fontSize: '1.1em',
      },
    },
    formLabel3: {
      fontWeight: 'bold',
      fontSize: '1.2em',
      display: 'flex',
      color: '#505050',
      justifyContent: 'flex-start',
      paddingLeft: '3.5em',
      paddingRight: '3.5em',
      paddingTop: '1.5em',
      paddingBottom: '1.75em',
      '@media (max-width: 550px)': {
        paddingLeft: '1.7em',
        paddingRight: '1.5em',
        fontSize: '1.1em',
      },
    },
    heatLoanFormBody: {
      backgroundColor: '#FFFFFF',
      display: 'flex',
      height: '100%',
      flexDirection: 'column',
      justifyContent: 'space-between',
      textAlign: 'left',
      fontSize: '0.9em',
      paddingTop: '3rem',
    },
    heatLoanFormPaper: {
      height: '85%',
    },
    heatLoanFormFile: {
      fontSize: '1.1em',
    },
    heatLoanFormUserInfo: {
      paddingLeft: '3.5em',
      paddingRight: '3.5em',
      display: 'flex',
      flexDirection: 'column',
      fontSize: '1.1em',
      justifyContent: 'space-around',
      '@media (max-width: 550px)': {
        paddingLeft: '1em',
        paddingRight: '1em',
      },
    },
    heatLoanFormUserInfoHODetails: {
      display: 'flex',
      flexDirection: 'column',
      fontSize: '1.1em',
      justifyContent: 'space-around',
      '@media (max-width: 550px)': {
        paddingLeft: '1em',
        paddingRight: '1em',
      },
    },
    heatLoanFormUserInfoUpload: {
      paddingLeft: '3.5em',
      paddingRight: '3.5em',
      display: 'flex',
      flexDirection: 'column',
      fontSize: '1.1em',
      justifyContent: 'space-around',
      '@media (max-width: 550px)': {
        paddingLeft: '1.5em',
        paddingRight: '1.5em',
      },
    },
    heatLoanFormInstallerInfo: {
      paddingLeft: '3.5em',
      paddingRight: '3.5em',
      display: 'flex',
      flexDirection: 'column',
      fontSize: '1.1em',
      justifyContent: 'space-around',
      '@media (max-width: 550px)': {
        paddingLeft: '1.5em',
        paddingRight: '1.5em',
      },
    },
    heatLoanFormHomeOwnerInfo: {
      paddingLeft: '2.5em',
      paddingTop: '1.5em',
      paddingBottom: '1.5em',
      fontSize: '1.25em',
    },
    heatLoanFormSubmit: {
      padding: '3.5em',
      display: 'flex',
      justifyContent: 'center',
      '@media (max-width: 550px)': {
        paddingLeft: '1.5em',
        paddingRight: '1.5em',
      },
    },
    heatLoanFormSubmitButton: {
      backgroundColor: '#F37320',
      color: '#FFFFFF',
      width: '30%',
      '@media (max-width: 550px)': {
        width: '50%',
      },
      height: '140%',
      fontSize: '1.2em',
      borderRadius: '0.6em',
    },
    heatLoanFormEnphaseLogoBox: {
      paddingTop: '2em',
      paddingLeft: '2em',
      display: 'flex',
      alignContent: 'center',
      justifyContent: 'flex-start',
      '@media (max-width: 550px)': {
        paddingTop: '1em',
        paddingLeft: '1em',
      },
    },
  }),
  { index: 1 },
)

export { useStyles }
